export default __webpack_public_path__ + "static/media/partially_cleared.362feedb.svg";